<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import Area from "@/components/c-input-area";


import { propertyService } from "../../../../services/managements/propertyservice/property.service";
import { customerService } from "../../../../services/contactservice/customer.service";

// import { service } from "../../../../services/managements/services/service";
// import { propertyServiceService } from "../../../../services/managements/propertyservice/propertyservice.service";
// import { utilityService } from "../../../../services/managements/utilities/utility.service";

// import { servicehelpers } from "../../../../services/servicehelpers";


import i18n from "../../../../i18n";
import Loading from "@/components/c-loading";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Utility Rcord Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading, 
    Button,
    Input,
    Select,
    Search,
    Area
    // ServiceRow
  },
  data() {
    return {
        projectList: {},
        propertyList: {},
        customerData: {},
        showCustomerInfo: false,

        //to submit data
        dataProject: '',
        dataProperty: '',
        dataCustomer: '',
        dataHandOverDate: '',
        dataNotation: '',
        dataElectrict: '',
        dataWatter: '',
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);     
    }


    // this.loadingDiscountTypeData();

  },
 
  methods: {
    loadingData: function(id) {
      this.fetchingStats = true;
      propertyService.getOne(id)
        .then(response => {
          if(id != 0){
            this.dataProject = response.data.project_id;
          }
          this.loadingSettings(response.setting);
        });

    },

    loadingSettings: function(setting) {
      this.projectList = {data: setting.projects};
    },

    onProjectChanged: function() {
        let id = this.dataProject;
        if(id) {
           propertyService.getDropdowns(id, 0).then(response => {
                this.propertyList = response;
                this.showCustomerInfo = false;
            });
        }
    },

    onPropertyChanged: function() {
        let id = this.dataProperty;
        if(id) {
           customerService.getOne(id).then(response => {
                this.customerData = response.data;
                this.showCustomerInfo = true;
            });
        }
    },

    submitSave: function() {
      
      this.tryingToSubmit = true;

      if(!this.dataElectrict || !this.dataWatter){
        return false;
      }

     let dataSubmit = {
          project_id: this.dataProject,
          property_id: this.dataProperty,
          customer_id: this.customerData.id,
          hand_over_date: this.dataHandOverDate,
          watter: this.dataWatter,
          electrict: this.dataElectrict,
          notation: this.dataNotation
        };
    propertyService.keyHandOver(dataSubmit)
    .then(response => {
        this.tryingToSubmit = false;
        console.log(response);
        if(response.status == 200) {
            this.$swal.fire({
            title: i18n.t('general.success.title'),
            text: i18n.t('general.success.message'),
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: i18n.t('general.ok'),
            cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
            if (result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                name: "manage-setting-property-service-id",
                params:  {id: this.dataProperty},
                });
            }
            });
        }
    });


    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "manage-property"
          });

        }
      });
    
    },

    clearForm: function() {

      this.dataProperty = 0;

    },





  },
};
</script>

<template>
  <Layout>
    <div>
      <PageHeader :items="[{
        text: $t('property.text'),
        href: '/manage/property',
      }, {
        text: $t('manage.wattert-and-electrict-record'),
        active: true
      }]" :title="$t('manage.wattert-and-electrict-record')" />
    </div>

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
                <div class="col-sm-9">
                    <div class="row">
                        <div class="col-md-6">
                            <Select
                                @change="onProjectChanged" 
                                :id="'project_id'"
                                v-model="dataProject"
                                :list="this.projectList"
                                :label="'property.project'"
                                :require="true"
                            /> 
                        </div>
                        <div class="col-lg-6">
                            <Search 
                            @change="onPropertyChanged" 
                            :id="'property_id'"
                            :editable="true"
                            v-model="dataProperty"
                            :list="this.propertyList"
                            :label="'property.text'" 
                            />
                        </div>
                    </div>
                    <div class="row">
                       <div class="col-sm-4">
                          <Input 
                            :type="'date'"
                            :id="'hand_over_date'"
                            v-model="dataHandOverDate"
                            :require="true"
                            :label="'manage.keyover.date'"  />
                       </div>
                        <div class="col-lg-4">
                            <Input 
                                :type="'text'"
                                :id="'watter'"
                                v-model="dataWatter"
                                :require="true"
                                :label="'manage.utility.watter'"  />
                        </div>
                        <div class="col-lg-4">
                            <Input 
                                :type="'text'"
                                :id="'electrict'"
                                v-model="dataElectrict"
                                :require="true"
                                :label="'manage.utility.electrict'"  />
                        </div>
                         <div class="col-lg-12">
                            <Area 
                                :rows="7"
                                :id="'notation'"
                                v-model="dataNotation"
                                :label="'income.notation'"  />
                        </div>
                    </div>
                </div>
                <div class="col-sm-3  shadow-lg p-2" v-if="this.showCustomerInfo">
                    <h5 class="pt-2">{{$t('customer.text')}}</h5>
                    <hr>
                    <table class="table table-lg table-hover">
                        <tbody>
                        <tr>
                            <td width="30%">{{$t('customer.name')}}</td>
                            <td>{{this.customerData.code}}</td>
                        </tr>
                       
                         <tr>
                            <td>{{$t('customer.code')}}</td>
                            <td>{{this.customerData.code}}</td>
                        </tr>
                         <tr>
                            <td>{{$t('customer.dob')}}</td>
                            <td>{{this.customerData.dob}}</td>
                        </tr>
                         <tr>
                            <td>{{$t('customer.nationality')}}</td>
                            <td>{{this.customerData.nationality}}</td>
                        </tr>
                         <tr>
                            <td>{{this.customerData.idType}}</td>
                            <td>{{this.customerData.id_no}}</td>
                        </tr>
                        <tr>
                            <td>{{$t('customer.address')}}</td>
                           <td>{{this.customerData.address}}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">

                    <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                        <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                        <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>

    </b-form> 
  </Layout>
</template>